import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UtilitiesService } from './common/shared/services/utilities.service';
import { ActivatedRoute } from '@angular/router';
import 'hammerjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None  // Use to disable CSS Encapsulation for this component
})
export class AppComponent {
  title = 'app';

  constructor(
    translate: TranslateService,
    public _utilitiesService: UtilitiesService,
    private _activatedRoute: ActivatedRoute) {
    this._utilitiesService.addMajorAction('Init');

    this._activatedRoute.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang === 'en') {
        translate.use(lang);
      } else {
        translate.setDefaultLang('se');
        translate.use('se');
      }
    });
  }

  initActive() {
    if (this._utilitiesService === null || this._utilitiesService === undefined) {
      return true;
    }
    return this._utilitiesService.isActionActive('Init');
  }
}
